var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "swiper" }, [
    _c("div", { staticClass: "swiper-container" }, [
      _c(
        "div",
        {
          ref: "swiperwrap",
          staticClass: "swiper-wrap",
          on: { transitionend: _vm.checkBorder }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.pagination
        ? _c(
            "div",
            { staticClass: "pagination" },
            _vm._l(_vm.indCount, function(item, index) {
              return _c("span", {
                key: index,
                staticClass: "indicator",
                class: { picked: _vm.currentIndex === index },
                on: {
                  click: function($event) {
                    return _vm.pickItem(index)
                  }
                }
              })
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.btn
        ? _c("div", { staticClass: "swiperbtn" }, [
            _c("div", { staticClass: "pre-btn", on: { click: _vm.preItem } }),
            _vm._v(" "),
            _c("div", { staticClass: "next-btn", on: { click: _vm.nextItem } })
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23225754", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23225754","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/swiper/index.vue
// module id = null
// module chunks = 